// src/utils/auth.js
import { ref, computed } from 'vue'

const user = ref(getUserFromStorage())

function getUserFromStorage() {
  try {
    const u = JSON.parse(localStorage.getItem('user'))
    if (u && u.status?.toLowerCase() === 'active') return u
  } catch {}
  return null
}

export function useAuth() {
  const isLoggedIn = computed(() => !!user.value)

  function setUser(u) {
    localStorage.setItem('user', JSON.stringify(u))
    user.value = u
  }

  function logout() {
    localStorage.removeItem('user')
    user.value = null
  }

  function getUser() {
    return user.value
  }

  return {
    user,
    isLoggedIn,
    setUser,
    logout,
    getUser
  }
}
